/* tslint:disable:file-name-casing no-commented-code */
import {
    inject,
    ObjectGraph,
} from '@jet/environment/dependencies/object-graph';
import { ObjectGraphType } from './object-graph-type';

// TODO:  Andorra revisit these before launch and do another scrub

/**
 * A list of supported features passed in by the host app.
 *
 * These are useful for checking for support without needing to resort to more
 * platform specific means (like checking host.platform or checking if a client
 * has OS version >= 22A123).
 *
 * These features should all be optional (?) booleans that default to false.
 * They should enable new features (so that old clients will default to
 * receiving the disabled behavior).
 *
 * Each feature should be documented and have a "Removal radar:" filed and
 * noted when the feature is temporary. For example, a feature added to
 * toggle presenting a new section can be removed once all shipping hosts
 * support the new section type. Features can be used for permanent platform
 * behavior as well (such as the kind of navigation stack). In these cases,
 * a removal radar should be omitted with a note.
 */
export interface HostFeatures {}

export class Features {
    constructor(private readonly features: HostFeatures) {}

    private static getHostFeatures(objectGraph: ObjectGraph): HostFeatures {
        const { features } = inject(ObjectGraphType.features, objectGraph);
        return features;
    }
}
